export enum ColorAttributes {
  // Be careful: The order of these properties is used for sorting
  // the default values when initialization the form.
  base = 'general_color_base_data_value_id',
  top = 'top_color_base_data_value_id',
  middle = 'middle_color_base_data_value_id',
  bottom = 'bottom_color_base_data_value_id',
}
